import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppBar, Toolbar, Box, Typography } from '@mui/material';
import { HeaderMenu } from 'components/header/HeaderMenu';
import { environmentConfig } from 'environmentConfig';
import styles from './Header.module.scss';
import { useTranslation } from 'react-i18next';
export const Header = () => {
    const { assetsBaseUrl } = environmentConfig;
    const logoUrl = `${assetsBaseUrl}/images/logo.png`;
    const { t } = useTranslation('header');
    return (_jsx(AppBar, { position: "relative", className: styles.header, elevation: 0, children: _jsxs(Toolbar, { className: styles.toolbar, disableGutters: true, children: [_jsxs(Box, { className: styles.brand, children: [_jsx(Box, { component: "img", src: logoUrl, alt: t('logoAlt'), className: styles.logo }), _jsx(Box, { className: styles.brandDivider }), _jsx(Typography, { variant: "h4", className: styles.productTitle, children: t('title') })] }), _jsx(HeaderMenu, {})] }) }));
};
